<div class="step-process" *ngIf="productInfo$ | async as productInfo">
	<input
		[attr.product]="productInfo.productId"
		type="range"
		class="step-process__range"
		[style.--progress]="progress + '%'"
		[min]="0"
		[max]="100"
		[(ngModel)]="progress"
		disabled
		[attr.current-step]="currentStep"
		[attr.current-percentage]="currentPercentage"
		[attr.total-steps]="totalSteps" />
</div>
